import { RootState } from '../../rootReducer';

export const cloudsAndContentSelectors = {
  getCloudsAndContentState: (state: RootState) => state.CloudsAndContentState,
};
